(function () {
    'use strict';

    function requiredDownloadConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/requiredDownloadConfiguration.html',
            scope: {
                parent: '=',
                requiredDownloadData: '=',
                linkedTemplatesList: '='
            },
            link: function (scope) {

            }
        };
    }

    requiredDownloadConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('requiredDownloadConfiguration', requiredDownloadConfiguration);
})();
